<script setup lang="ts">
defineOptions({
    name: 'CropperRange'
});

const model = defineModel<number>({ required: true });
const props = withDefaults(defineProps<{
    min?: number;
    max?: number;
    step?: number | string;
    disabled?: boolean;
}>(), {
    min: 0,
    max: 100,
    step: 1,
    disabled: false
});

const emit = defineEmits<{
    (e: 'input', value: number): void;
    (e: 'change', event: Event): void;
}>();
</script>

<template>
    <IdeoFormRange
        v-model="model"
        class="cropper-range"
        :min="props.min"
        :max="props.max"
        :step="props.step"
        :disabled="props.disabled"
        @input="emit('input', $event)"
        @change="emit('change', $event)"
    />
</template>
